
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api/api';
import { useNavigate } from 'react-router-dom';

const ActivateAccount = () => {
    const navigate = useNavigate();
    const { uid, token } = useParams(); // URLからuidとtokenを取得
    const [statusMessage, setStatusMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const activateAccount = async () => {
            try {
                const response = await api.get(`${process.env.REACT_APP_API_URL}/accounts/api/activate/${uid}/${token}/`);
                setStatusMessage(response.data.detail);
            } catch (err) {
                setError('アカウントの有効化に失敗しました。トークンが無効か期限切れです。');
            }
        };

        activateAccount();
    }, [uid, token]);

    
    const toLoginPage = () => { 
        navigate('/login')
    }

    return (
        <div className='background'>
            {statusMessage ? (
                <div className='form-main'>
                    <p>{statusMessage}</p>
                    <button type="submnit" className="btn to-login-button" onClick={toLoginPage} >ログインページへ移動</button>
                </div>
                
            ) : (
                <p>{error || 'アカウントを有効化しています...'}</p>
            )}
        </div>
    );
};

export default ActivateAccount;
